"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefined = void 0;
var tslib_1 = require("tslib");
var forIn_1 = tslib_1.__importDefault(require("lodash/forIn"));
var isObject_1 = tslib_1.__importDefault(require("lodash/isObject"));
// TODO: deprecare this because its unpredictable
var removeUndefined = function (item) {
    if ((0, isObject_1.default)(item) && !Array.isArray(item)) {
        var obj_1 = tslib_1.__assign({}, item);
        (0, forIn_1.default)(obj_1, function (val, key) {
            if (typeof val !== 'function' && !Array.isArray(val)) {
                if (val === undefined) {
                    delete obj_1[key];
                }
                else if (typeof val === 'object') {
                    obj_1[key] = (0, exports.removeUndefined)(val);
                }
            }
        });
        return obj_1;
    }
    return item;
};
exports.removeUndefined = removeUndefined;
